import Vue from 'vue'
import Router from 'vue-router'
import container from '../components/container/container'
import home from '../views/home/home'
import question from '../views/question/question'
import login from '../views/login/login'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '/container/home',
      redirect:'/container/home'
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path:'/container',
      name:'container',
      component:container,
      children:[
        {
          path: 'home',
          name: 'home',
          component: home,
        },
        {
          path: 'question',
          name: 'question',
          component: question,
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js